// Single source of truth for the app version shown in the UI.
// Bump this on every deployment (1.1.0 -> 1.2.0 -> 1.3.0 ...).
export const APP_VERSION = '1.11.0'
